var fillPercent = 0;

window.updateProgressBar = async function ({ cartTotalArg, renderApp = true } = {}) {

    const fillEl = document.querySelector('.progress-fill');
    if (fillEl) {
        fillEl.style.width = `${(fillPercent)}%`;
    }
  
    let cartTotal = cartTotalArg;
    
    if (typeof cartTotalArg === 'undefined') {
        cart = await getCart(); 
        cartTotal = cart.total_price
    }

    //console.log('CART', cart);

    const totalPriceNumber = cartTotal / 100; 
    const totalFormatted = totalPriceNumber.toFixed(2); 

    const loader = document.querySelector('.wrapper-loading');
    if (loader && cart.items.length > 0) {
        loader.classList.add('active'); 
    } else {
      loader.classList.remove('active');
    }
    
    if (renderApp) {
        setTimeout(async () => {

            const markers = [...document.querySelectorAll('.marker')];
            if (!markers.length) return;
        
            const offsetWidth = parseInt((100 / markers.length) / 2);
        
            markers.sort((a, b) => parseInt(a.dataset.amount) - parseInt(b.dataset.amount));
        
            const thresholds = markers.map(m => parseInt(m.dataset.amount));
            const allThresholds = [0, ...thresholds];
            const segmentCount = allThresholds.length - 1;
        
            const lastThreshold = allThresholds[allThresholds.length - 1];
        
            if (cartTotal >= lastThreshold) {
                fillPercent = 100;
            } else {
                for (let i = 0; i < segmentCount; i++) {
                    const t0 = allThresholds[i];
                    const t1 = allThresholds[i + 1];
                    if (cartTotal >= t0 && cartTotal < t1) {
                        let fraction = (cartTotal - t0) / (t1 - t0);
                        fraction = Math.min(fraction, 0.95);
                        const barSegment = i + fraction;
                        fillPercent = (barSegment / segmentCount) * 100;
                        if (fillPercent > offsetWidth) {
                            fillPercent = fillPercent - (offsetWidth);
                        }
                        break;
                    }
                }
            }
        
            if (fillEl) {
                fillEl.style.width = `${(fillPercent)}%`;
            }
        
            markers.forEach(marker => {
                const amount = parseInt(marker.dataset.amount);
                marker.classList.toggle('active', cartTotal >= amount);
            });
        
            const messageGiftTop = document.querySelector('.gift-info-top');
        
            const nextMarker = markers.find(marker => {
                return parseInt(marker.dataset.amount) > cartTotal;
            });
        
            if (nextMarker) {
                const needed = parseInt(nextMarker.dataset.amount) - cartTotal;
                const neededEuros = (needed / 100).toFixed(2);
        
                const giftName = nextMarker.dataset.giftTitles;
                const template = KROWN.settings.cart.remainingLabel;
                const message = template
                    .replace('{{ amount }}', neededEuros)
                    .replace('{{ gift_name }}', giftName);
                const rawHtml = decodeHTML(message);
        
                messageGiftTop.innerHTML = rawHtml;
            } else {
                messageGiftTop.innerHTML = `<strong>${KROWN.settings.cart.allGiftsInCart}</strong>`;
            }
        
            const cartItems = [...document.querySelectorAll('.cart-item')];
            const freeItems = [];
            const normalItems = [];
        
            cartItems.forEach(item => {
                if (item.dataset.propertie === '_planet_free_gift') {
                    freeItems.push(item);
                } else {
                    normalItems.push(item);
                }
            });
        
            const cartContainer = document.querySelector('#AjaxCartForm .cart__items .normal-items');
            const giftsContainer = document.querySelector('#AjaxCartForm .cart__items .gifts-container');
            if (!cartContainer) return;
        
            cartContainer.innerHTML = '';
            giftsContainer.innerHTML = '';
            normalItems.forEach(item => cartContainer.appendChild(item));
            freeItems.forEach(item => giftsContainer.appendChild(item));
          
            const totalFormatted = parseFloat(cartTotal / 100).toFixed(2);
            const payButtonTotal = document.querySelector('.button--custom .button-custom__total');
            if (payButtonTotal) {
              payButtonTotal.textContent = `${totalFormatted}€`;
            }
          
            document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
              elm.textContent = `${totalFormatted}€`;
            });

            loader.classList.remove('active');

            document.querySelectorAll('.cart-item').forEach(itemEl => {
                if (itemEl.querySelector('[data-cart-variant-option]')) {
                  populateAllSelects(itemEl);
                }
            });
            
            syncLiquidToStorage();
            hydrateAttributesFromStorage();

            const eventName = 'progress-bar:updated';
            document.dispatchEvent(new CustomEvent(eventName, {
              detail: {
                cart: cart 
              }
            }));

        }, 1000);

    } else {

        const cartContainer = document.querySelector('#AjaxCartForm .cart__items .normal-items');
        const giftsContainer = document.querySelector('#AjaxCartForm .cart__items .gifts-container');

        cartContainer.innerHTML = '';
        giftsContainer.innerHTML = '';
        normalItems.forEach(item => cartContainer.appendChild(item));
        freeItems.forEach(item => giftsContainer.appendChild(item));
        loader.classList.remove('active');
    }
  
    const payButtonTotal = document.querySelector('.button--custom .button-custom__total');
    if (payButtonTotal) {
        payButtonTotal.textContent = `${totalFormatted}€`;
    }

    document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
        elm.textContent = `${totalFormatted}€`;
    });
    
    const cartTotalEls = document.querySelectorAll('main-header a.desktop-cart-button');
    const color = cartTotal > 0
        ? KROWN.settings.cart.customButtonColor
        : KROWN.settings.cart.textColor;
    cartTotalEls.forEach(elm => {
        elm.style.backgroundColor = color;
    });

    buildGiftThresholdMap();
    assignThresholdsToCartItems();

}


window.checkCartDiscount = async function (cartLevelDiscounts) {
  const discountField = document.querySelector('#site-cart-sidebar .limoniapps-discountninja-cartdiscountfield-input');

  if (cartLevelDiscounts.length >= 2) {
    if (discountField) {
      discountField.disabled = true; 
      discountField.classList.add('discount-field--disabled');
    }
  } else {
    discountField.classList.remove('discount-field--disabled');
  }
}

let lastUpdateTime = 0;
const DEBOUNCE_MS = 250;

window.updateProgressBarDebounced = async function (cartTotal) {
  const now = Date.now();
  if (now - lastUpdateTime < DEBOUNCE_MS) {
    return;
  }
  lastUpdateTime = now;

  window.updateProgressBar({ cartTotalArg: cartTotal });
}

document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-cart-variant-option]')) return;
  
    const cartItemEl = event.target.closest('.cart-item');
    if (!cartItemEl) return;
  
    const optionIndex = event.target.dataset.optionIndex; 
    const thresholdCents = parseInt(cartItemEl.dataset.threshold, 10) || 0;
    const optionName = event.target.dataset.variantName; 
    const selectedValue = event.target.value;
  
    cartItemEl.dataset[`option${optionIndex}Value`] = selectedValue;

    try {
      repopulateNextSelects(cartItemEl, optionIndex);
    } catch (err) {
      console.warn('No se pudo re-popular los selects:', err);
    }
  
    const option1Value = cartItemEl.dataset.option0Value;
    const option2Value = cartItemEl.dataset.option1Value;
    const option3Value = cartItemEl.dataset.option2Value;
  
    const variants = JSON.parse(cartItemEl.dataset.variants);

    const matchingVariant = variants.find(v =>
      (!v.option1 || v.option1 === option1Value) &&
      (!v.option2 || v.option2 === option2Value) &&
      (!v.option3 || v.option3 === option3Value)
    );
  
    if (!matchingVariant) return;
    const newVariantId = parseInt(matchingVariant.id, 10);
    const lineIndex = parseInt(cartItemEl.dataset.line, 10);
  
    //console.log('SELECTOR ', lineIndex, newVariantId, optionName, selectedValue);
    updateGiftVariant(lineIndex, newVariantId, thresholdCents)
  
});

async function updateGiftVariant(line, newVariantId, thresholdCents) {
    await removeLineItem(line);
    await addLineItem(newVariantId, thresholdCents);
    window.refreshCart();

    console.log('updateGiftVariant', line, newVariantId);
}

async function removeLineItem(line) {
    const body = JSON.stringify({
      line: parseInt(line, 10),
      quantity: 0
    });
  
    const response = await fetch(KROWN.settings.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body
    });
    if (!response.ok) {
      throw new Error('No se pudo eliminar el item');
    }
    return response.json();
}

async function addLineItem(variantId, thresholdCents) {

    const body = JSON.stringify({
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: {
            '_planet_free_gift': "true",
            '_planet_free_gift_changed': "true",
            '_planet_free_gift_changed_threshold': thresholdCents
          }
        }
      ]
    });
  
    const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body
    });
    if (!response.ok) {
      throw new Error('No se pudo añadir la variante nueva');
    }
    return response.json();
}

window.removeChangedGiftsBelowCartTotal = async function (cartTotalArg) {

    let cartTotal = cartTotalArg;
    
    if (typeof cartTotalArg === 'undefined') {
        cart = await getCart(); 
        cartTotal = cart.total_price
    }

    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const itemsToRemove = [];
  
      cart.items.forEach((item, index) => {
        const line = index + 1; 
        if (item.properties && item.properties._planet_free_gift_changed_threshold) {
          const giftThreshold = parseInt(item.properties._planet_free_gift_changed_threshold, 10) || 0;

          if (giftThreshold > cartTotal) {
            itemsToRemove.push(line);
          }
        }
      });
  
      if (!itemsToRemove.length) return;
  
      for (let line of itemsToRemove) {
        await fetch(KROWN.settings.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript'
          },
          body: JSON.stringify({ line, quantity: 0 })
        });
      }
  
      window.refreshCart();
  
    } catch (e) {
      console.error('Error removing changed gifts:', e);
    }
}

window.removeAllPlanetGifts = (function() {
  let isRunning = false;
  let lastCartToken = null;
  
  return async function(cart) {
    if (cart.token === lastCartToken || isRunning) return;
    isRunning = true;
    lastCartToken = cart.token;
    
    try {
      const linesToRemove = [];
      cart.items.forEach((item, idx) => {
        const props = item.properties || {};
        const isGift = Object.prototype.hasOwnProperty.call(props, '_planet_free_gift');
        if (isGift) {
          linesToRemove.push(idx + 1);
        }
      });
      
      window.__giftRuns = (window.__giftRuns || 0) + 1;
      console.log('removeAllPlanetGifts run #', window.__giftRuns, 'ITEMS', linesToRemove);
      
      const removals = linesToRemove.map(line =>
        fetch(window.Shopify.routes.root + '/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/javascript'},
          body: JSON.stringify({ line, quantity: 0 })
        })
      );
      
      if (removals.length) {
        await Promise.all(removals); 
        window.refreshCart();
      }
    } finally {
      isRunning = false;
    }
  };
})();

function buildGiftThresholdMap() {
    window.giftThresholdMap = {}; 
  
    const markers = document.querySelectorAll('.marker');
    markers.forEach(marker => {
      const thresholdStr = marker.dataset.amount;
      const threshold = parseInt(thresholdStr, 10);
      const giftIdsStr = marker.dataset.giftIds; 
      if (!giftIdsStr) return;
  
      const giftIds = giftIdsStr.split(',').map(id => id.trim());
      giftIds.forEach(id => {
        window.giftThresholdMap[id] = threshold;
      });
    });

}
  
function assignThresholdsToCartItems() {
    const cartItems = document.querySelectorAll('.cart-item[data-product-id]');
    cartItems.forEach(item => {

      if (item.dataset.propertie !== '_planet_free_gift') return;
  
      const productId = item.dataset.productId; 
      const threshold = window.giftThresholdMap[productId] || 0;
      item.dataset.threshold = threshold;
    });
}
  

async function getCart() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        //console.log('CART DATA:', cart);
        return cart;
    } catch (error) {
        console.error('Error fetching cart:', error);
        return 0;
    }
}

function populateAllSelects(itemEl) {
    const variants = JSON.parse(itemEl.dataset.variants);
    const allSelects = [...itemEl.querySelectorAll('[data-cart-variant-option]')]
      .sort((a, b) => parseInt(a.dataset.optionIndex) - parseInt(b.dataset.optionIndex));
  
    let knownValues = {};
  
    allSelects.forEach((selectEl, idx) => {
      fillOptionsFor(selectEl, variants, knownValues, idx);
      knownValues[`option${idx + 1}`] = selectEl.value;

      itemEl.dataset[`option${idx}Value`] = selectEl.value;
    });
}

function fillOptionsFor(selectEl, variants, knownValues, optionIndex) {

    const optionKey = `option${optionIndex + 1}`; 
  
    selectEl.innerHTML = '';
  
    let possibleVariants = variants.filter(v => v.available);
  
    for (let i = 1; i <= optionIndex; i++) {
      const prevKey = `option${i}`; 
      const prevVal = knownValues[prevKey];
      if (prevVal) {
        possibleVariants = possibleVariants.filter(v => v[prevKey] === prevVal);
      }
    }
  
    const values = [...new Set(possibleVariants.map(v => v[optionKey]).filter(Boolean))];
  
    values.forEach(val => {
      const opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      selectEl.appendChild(opt);
    });
  
    const savedVal = selectEl.closest('.cart-item').dataset[`option${optionIndex}Value`];
    if (savedVal && values.includes(savedVal)) {
      selectEl.value = savedVal;
    }
}

function repopulateNextSelects(cartItemEl, fromIndex) {
    const allSelects = [...cartItemEl.querySelectorAll('[data-cart-variant-option]')]
      .sort((a, b) => parseInt(a.dataset.optionIndex, 10) - parseInt(b.dataset.optionIndex, 10));
  
    const variants = JSON.parse(cartItemEl.dataset.variants);
  
    let knownValues = {};
    for (let i = 0; i <= fromIndex; i++) {
      knownValues[`option${i + 1}`] = allSelects[i].value;
    }
  
    for (let i = fromIndex + 1; i < allSelects.length; i++) {
      if (!allSelects[i]) break; 
      fillOptionsFor(allSelects[i], variants, knownValues, i);
      knownValues[`option${i + 1}`] = allSelects[i].value;
    }
}

function syncLiquidToStorage() {
  const w = document.querySelector('.gift-progress-bar__wrapper');
  if (!w || !w.dataset.customerStatus) return;
  sessionStorage.setItem('customerStatus', w.dataset.customerStatus);
  if (w.dataset.customer) {
    sessionStorage.setItem('customerId', w.dataset.customer);
  } else {
    sessionStorage.removeItem('customerId');
  }
}

function hydrateAttributesFromStorage() {
  const w = document.querySelector('.gift-progress-bar__wrapper');
  if (!w) return;
  if (!w.dataset.customerStatus || w.dataset.customerStatus === 'guest') {
    const storedStatus = sessionStorage.getItem('customerStatus');
    if (storedStatus && storedStatus !== 'guest') {
      w.dataset.customerStatus = storedStatus;
      const storedId = sessionStorage.getItem('customerId');
      if (storedId) w.dataset.customer = storedId;
    }
  }
}

window.CustomerSession = {
  isLogged() {
    return (sessionStorage.getItem('customerStatus') || 'guest') !== 'guest';
  },
  isPatrocinio() {
    return sessionStorage.getItem('customerStatus') === 'patrocinio';
  },
  getId() {
    return sessionStorage.getItem('customerId') || null;
  }
};

function decodeHTML(escapedStr) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(escapedStr, 'text/html');
    return doc.documentElement.textContent;
}

document.addEventListener('DOMContentLoaded', function () {

    const intervalTime = 5000;
    const rightArrow = document.querySelector('.announcement-bar__content-nav--right');
    const leftArrow = document.querySelector('.announcement-bar__content-nav--left');
    let direction = 'right';

    function navigateAnnouncements() {
        if (direction === 'right') {
            rightArrow.click();
            if (rightArrow.classList.contains('announcement-bar__content-nav--disabled')) {
                direction = 'left';
            }
        } else {
            leftArrow.click();
            if (leftArrow.classList.contains('announcement-bar__content-nav--disabled')) {
                direction = 'right';
            }
        }
    }

    setInterval(navigateAnnouncements, intervalTime);

    const header = document.getElementById('site-header');
    const stickyClass = 'sticky-header22';
    const headerHeight = header.offsetHeight;

    const excludedPage = '/cart';

    function makeHeaderSticky() {
        if (window.location.pathname === excludedPage) {
            return;
        }

        if (window.scrollY > 0) {
            if (!header.classList.contains(stickyClass)) {
                header.classList.add(stickyClass);
                document.body.style.paddingTop = headerHeight + 'px';
            }
        } else {
            if (header.classList.contains(stickyClass)) {
                header.classList.remove(stickyClass);
                document.body.style.paddingTop = '0';
            }
        }
    }

    window.addEventListener('scroll', makeHeaderSticky);


});

document.addEventListener("DOMContentLoaded", function () {
    const elementoAlergenos = document.getElementById("ingredientes");

    const mostrarAlergenos = document.getElementById("alergenos_imagenes");

    if (!elementoAlergenos) {
        return;
    }

    const texto = elementoAlergenos.textContent.toLowerCase();

    const palabrasClave = {
        // Gluten / Cereales
        "cereales": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "gluten": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "trigo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "cebada": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "avena": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "centeno": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "espelta": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "céréales": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",         // FR
        "gluten (fr)": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "blé": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "orge": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "avoine": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "seigle": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "épeautre": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "cereais": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",         // PT
        "glúten": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "trigo (pt)": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "cevada": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "aveia": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "centeio": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
        "espelta (pt)": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/gluten.png",
    
        // Crustáceos
        "crustaceo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "crustáceo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "marisco": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "gambas": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "cangrejo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "crustacé": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",        // FR
        "fruits de mer": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "crevettes": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "crabe": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "crustáceos": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",      // PT
        "mariscos": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "camarões": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
        "caranguejo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/marisco.png",
    
        // Huevo
        "huevo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/alergeno-huevo.png",
        "albúmina": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/alergeno-huevo.png",
        "oeuf": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/alergeno-huevo.png", // FR
        "albumine": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/alergeno-huevo.png",
        "ovo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/alergeno-huevo.png",       // PT
        "albumina": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/alergeno-huevo.png",
    
        // Pescado
        "pescado": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/pescado.png",
        "poisson": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/pescado.png",         // FR
        "peixe": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/pescado.png",           // PT
    
        // Cacahuetes
        "cacahuetes": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/cacahuetes.png",
        "arachides": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/cacahuetes.png",     // FR
        "amendoins": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/cacahuetes.png",     // PT
    
        // Soja
        "soja": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/soja.png",
        "soya": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/soja.png",
        "tofu": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/soja.png",
        "soja (fr)": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/soja.png",           // FR/PT (idéntico)
    
        // Lácteos
     
        "suero": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "lacteos": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "lácteos": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "leche": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "yogur": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "mantequilla": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "queso": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "nata": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "lactosa": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "produits laitiers": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",  // FR
        "sériques": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",  
        "lait": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "yaourt": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "beurre": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "fromage": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "crème": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "lactose": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "laticínios": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",         // PT
        "sérica": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",  
        "leite": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "iogurte": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "manteiga": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "queijo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "natas": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",
        "lactose (pt)": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/leche.png",

      // Frutos secos (frutos de cáscara)
      "frutos secos": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "frutos de cáscara": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "almendra": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "nueces": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "avellana": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "anacardo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "pistacho": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "fruits à coque": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png", // FR
      "amande": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "noix": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "noisette": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "noix de cajou": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "pistache": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "frutos de casca rija": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png", // PT
      "amêndoa": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "nozes": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "avelã": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "caju": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      "pistácio": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/frutos-de-cascara.png",
      
      // Apio
      "apio": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/apio.png",
      "céleri": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/apio.png", // FR
      "aipo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/apio.png",   // PT
      
      // Mostaza
      "mostaza": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/mostaza.png",
      "moutarde": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/mostaza.png", // FR
      "mostarda": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/mostaza.png", // PT
      
      // Sésamo
      "sesamo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sesamo.png",
      "sésamo": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sesamo.png",
      "graines de sésame": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sesamo.png", // FR
      "sésamo (pt)": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sesamo.png", // PT
      
      // Sulfitos
      "sulfito": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sulfitos.png",
      "dióxido de azufre": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sulfitos.png",
      "sulfites": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sulfitos.png", // FR
      "anhydride sulfureux": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sulfitos.png",
      "sulfitos": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sulfitos.png", // PT
      "dióxido de enxofre": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/sulfitos.png",
      
      // Altramuces
      "altramuces": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/altramuces.png",
      "lupin": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/altramuces.png", // FR
      "tremoço": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/altramuces.png", // PT
      
      // Moluscos
      "moluscos": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png",
      "mejillones": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png",
      "almejas": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png",
      "mollusques": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png", // FR
      "moules": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png",
      "palourdes": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png",
      "moluscos (pt)": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png", // PT
      "mexilhões": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png",
      "amêijoas": "https://cdn.shopify.com/s/files/1/0660/8545/3981/files/moluscos.png",
              
    };

    const alergenosEncontrados = [];
    Object.keys(palabrasClave).forEach(palabra => {
        if (texto.includes(palabra)) {
            alergenosEncontrados.push({
                palabra: palabra,
                imagen: palabrasClave[palabra]
            });
        }
    });

    //elementoAlergenos.innerHTML = "";

    alergenosEncontrados.forEach(alergeno => {
        const img = document.createElement("img");
        img.src = alergeno.imagen;
        img.alt = `Imagen del alérgeno: ${alergeno.palabra}`;
        img.title = `Alérgeno: ${alergeno.palabra}`;
        img.classList.add("alergeno-img");
        mostrarAlergenos.appendChild(img);
    });
});

/*NOTIFICACIÓN FAV*/
function showNotification(message) {
    const notification = document.getElementById('notification-fav');
    if (!notification) return;
    notification.textContent = message;
    notification.classList.add('notification-visible-fav');

    setTimeout(() => {
        notification.classList.remove('notification-visible-fav');
    }, 3000);
}


/* CART */
document.addEventListener('DOMContentLoaded', function () {
  
    updateProgressBarDebounced();
    buildGiftThresholdMap();

    const noteLabel = document.querySelector('.cart-note-toggle .cart-note-trigger');
    const noteTextarea = document.querySelector('.cart-page-note');
  
    if (!noteLabel || !noteTextarea) return;
    noteLabel.addEventListener('click', (e) => {
        //console.log('click');
        e.preventDefault();
        noteTextarea.classList.toggle('hidden');
        if (!noteTextarea.classList.contains('hidden')) {
            noteTextarea.focus();
        }
    }, { capture: true });

    document.querySelectorAll('.cart-item').forEach(itemEl => {
        if (itemEl.querySelector('[data-cart-variant-option]')) {
          populateAllSelects(itemEl);
        }
    });

});

document.addEventListener('DOMContentLoaded', async () => {
    const url = new URL(location.href);
    if (url.searchParams.get('_refresh_cart')) {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({})
          });
          window.refreshCart();
        } catch (e) {
          console.error('Error refrescando el carrito:', e);
        }
    }
});
